// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabPane_gotaO {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.tabPane_gotaO .tabContent_sgtI6 {
  font: normal 16px/26px Inter;
  flex: 1;
  color: #394756;
  overflow: auto;
  position: relative;
}
.tabPane_gotaO .tabs_VDba7 {
  padding-top: var( --size-padMedium );
}
.tabPane_gotaO .tabLine_n1B4f {
  flex: 0 0 2px;
  background-color: var( --color-base200 );
}
.tabPane_gotaO .tab_jqcaO {
  font: normal 15px/24px Inter;
  color: var( --color-base500 );
  padding: var( --size-padMedium );
  min-width: 100px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  background-color: transparent;
}
.tabPane_gotaO .tab_jqcaO[data-active=true] {
  font: 600 15px/24px Inter;
  color: var( --color-brand500 );
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 2px;
  border-bottom-color: var( --color-brand500 );
}
.tabPane_gotaO .tab_jqcaO:hover {
  color: var( --color-brand500 );
}
.tabPane_gotaO .tab_jqcaO:hover[data-active=true] {
  color: var( --color-brand500 );
  background-color: transparent;
}
.tabPane_gotaO .tab_jqcaO[disabled] {
  color: var( --color-base300 );
  background-color: transparent;
}
.tabPane_gotaO.tabPane-bottom_BkBrQ {
  display: flex;
  flex-direction: column-reverse;
}
.tabPane_gotaO.tabPane-bottom_BkBrQ .tabContent_sgtI6 {
  border-top: 1px solid var( --color-background3 );
  border-left: 1px solid var( --color-background3 );
  border-right: 1px solid var( --color-background3 );
  border-bottom: 0px solid var( --color-background3 );
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.tabPane_gotaO.tabPane-bottom_BkBrQ .tabs_VDba7 {
  display: flex;
  justify-content: flex-end;
}
.tabPane_gotaO.tabPane-bottom_BkBrQ .tab_jqcaO {
  border-top: var( --size-padSmall ) solid transparent;
  margin-top: -4px;
  border-bottom: none;
}
.tabPane_gotaO.tabPane-bottom_BkBrQ .tab_jqcaO[data-active=true] {
  border-top-color: var( --color-brand1 );
}
.tabPane_gotaO.tabPane-mobileDetailViewTabs_cduMd .tabLine_n1B4f {
  flex: 0 0 0px;
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw {
  border: 1px solid var( --color-base050 );
  display: flex;
  flex-direction: row;
  background-color: var( --color-white );
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw .tabs_VDba7 {
  width: 200px;
  display: flex;
  box-shadow: 3px 4px 4px rgba(0, 0, 0, 0.1);
  align-items: flex-start;
  flex-direction: column;
  background-color: #f9fbfc;
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw .tabLine_n1B4f {
  flex: 0 0 0px;
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw .tab_jqcaO {
  color: var( --color-base600 );
  width: 184px;
  height: 48px;
  font-size: var( --size-bodySmall );
  text-align: left;
  font-weight: 600;
  margin-left: auto;
  padding-left: var( --size-padLarge );
  margin-right: auto;
  border-radius: 12px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw .tab_jqcaO[data-active=true] {
  color: var( --color-brand500 );
  margin-bottom: 0px;
  background-color: var( --color-base100 );
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw .tab_jqcaO:hover {
  color: var( --color-brand500 );
  background-color: var( --color-base050 );
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw .tab_jqcaO:hover[data-active=true] {
  color: var( --color-brand500 );
  background-color: var( --color-base100 );
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw.tabPane-settingsTabs_ayNwm {
  height: 100%;
  background-color: var( --color-white );
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw.tabPane-settingsTabs_ayNwm .tabContent_sgtI6 {
  width: 100%;
  background-color: var( --color-base050 );
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw.tabPane-settingsTabs_ayNwm .tabs_VDba7 {
  width: 0px;
  min-height: 0px;
  background-color: var( --color-white );
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw.tabPane-settingsTabs_ayNwm .tab_jqcaO {
  font: normal 15px/24px Inter;
  color: #394756;
  width: 100%;
  height: 48px;
  padding: var( --size-pad12 ) var( --size-padLarge );
  transform: scale( 0, 0 );
  border-radius: 0px;
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw.tabPane-settingsTabs_ayNwm .tab_jqcaO[data-active=true] {
  font: 700 15px/24px Inter;
  color: var( --color-brand600 );
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw.tabPane-settingsTabs_ayNwm .tab_jqcaO:hover {
  color: var( --color-brand500 );
  background-color: var( --color-white );
}
.tabPane_gotaO.tabPane-detailViewTabs_VHPyw.tabPane-settingsTabs_ayNwm .tab_jqcaO:hover[data-active=true] {
  background-color: var( --color-brand050 );
}
.tabPane_gotaO.tabPane-tempUser_JWotW .tabs_VDba7 {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  justify-content: space-evenly;
}
.tabPane_gotaO.tabPane-tempUser_JWotW .tab_jqcaO {
  width: 33%;
}`, "",{"version":3,"sources":["webpack://./src/theme/TabPane.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,OAAO;EACP,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,4CAA4C;AAC9C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gDAAgD;EAChD,iDAAiD;EACjD,kDAAkD;EAClD,mDAAmD;EACnD,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ","sourcesContent":[".tabPane {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.tabPane .tabContent {\n  font: normal 16px/26px Inter;\n  flex: 1;\n  color: #394756;\n  overflow: auto;\n  position: relative;\n}\n.tabPane .tabs {\n  padding-top: var( --size-padMedium );\n}\n.tabPane .tabLine {\n  flex: 0 0 2px;\n  background-color: var( --color-base200 );\n}\n.tabPane .tab {\n  font: normal 15px/24px Inter;\n  color: var( --color-base500 );\n  padding: var( --size-padMedium );\n  min-width: 100px;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  background-color: transparent;\n}\n.tabPane .tab[data-active=true] {\n  font: 600 15px/24px Inter;\n  color: var( --color-brand500 );\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 2px;\n  border-bottom-color: var( --color-brand500 );\n}\n.tabPane .tab:hover {\n  color: var( --color-brand500 );\n}\n.tabPane .tab:hover[data-active=true] {\n  color: var( --color-brand500 );\n  background-color: transparent;\n}\n.tabPane .tab[disabled] {\n  color: var( --color-base300 );\n  background-color: transparent;\n}\n.tabPane.tabPane-bottom {\n  display: flex;\n  flex-direction: column-reverse;\n}\n.tabPane.tabPane-bottom .tabContent {\n  border-top: 1px solid var( --color-background3 );\n  border-left: 1px solid var( --color-background3 );\n  border-right: 1px solid var( --color-background3 );\n  border-bottom: 0px solid var( --color-background3 );\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.tabPane.tabPane-bottom .tabs {\n  display: flex;\n  justify-content: flex-end;\n}\n.tabPane.tabPane-bottom .tab {\n  border-top: var( --size-padSmall ) solid transparent;\n  margin-top: -4px;\n  border-bottom: none;\n}\n.tabPane.tabPane-bottom .tab[data-active=true] {\n  border-top-color: var( --color-brand1 );\n}\n.tabPane.tabPane-mobileDetailViewTabs .tabLine {\n  flex: 0 0 0px;\n}\n.tabPane.tabPane-detailViewTabs {\n  border: 1px solid var( --color-base050 );\n  display: flex;\n  flex-direction: row;\n  background-color: var( --color-white );\n}\n.tabPane.tabPane-detailViewTabs .tabs {\n  width: 200px;\n  display: flex;\n  box-shadow: 3px 4px 4px rgba(0, 0, 0, 0.1);\n  align-items: flex-start;\n  flex-direction: column;\n  background-color: #f9fbfc;\n}\n.tabPane.tabPane-detailViewTabs .tabLine {\n  flex: 0 0 0px;\n}\n.tabPane.tabPane-detailViewTabs .tab {\n  color: var( --color-base600 );\n  width: 184px;\n  height: 48px;\n  font-size: var( --size-bodySmall );\n  text-align: left;\n  font-weight: 600;\n  margin-left: auto;\n  padding-left: var( --size-padLarge );\n  margin-right: auto;\n  border-radius: 12px;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.tabPane.tabPane-detailViewTabs .tab[data-active=true] {\n  color: var( --color-brand500 );\n  margin-bottom: 0px;\n  background-color: var( --color-base100 );\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.tabPane.tabPane-detailViewTabs .tab:hover {\n  color: var( --color-brand500 );\n  background-color: var( --color-base050 );\n}\n.tabPane.tabPane-detailViewTabs .tab:hover[data-active=true] {\n  color: var( --color-brand500 );\n  background-color: var( --color-base100 );\n}\n.tabPane.tabPane-detailViewTabs.tabPane-settingsTabs {\n  height: 100%;\n  background-color: var( --color-white );\n}\n.tabPane.tabPane-detailViewTabs.tabPane-settingsTabs .tabContent {\n  width: 100%;\n  background-color: var( --color-base050 );\n}\n.tabPane.tabPane-detailViewTabs.tabPane-settingsTabs .tabs {\n  width: 0px;\n  min-height: 0px;\n  background-color: var( --color-white );\n}\n.tabPane.tabPane-detailViewTabs.tabPane-settingsTabs .tab {\n  font: normal 15px/24px Inter;\n  color: #394756;\n  width: 100%;\n  height: 48px;\n  padding: var( --size-pad12 ) var( --size-padLarge );\n  transform: scale( 0, 0 );\n  border-radius: 0px;\n}\n.tabPane.tabPane-detailViewTabs.tabPane-settingsTabs .tab[data-active=true] {\n  font: 700 15px/24px Inter;\n  color: var( --color-brand600 );\n}\n.tabPane.tabPane-detailViewTabs.tabPane-settingsTabs .tab:hover {\n  color: var( --color-brand500 );\n  background-color: var( --color-white );\n}\n.tabPane.tabPane-detailViewTabs.tabPane-settingsTabs .tab:hover[data-active=true] {\n  background-color: var( --color-brand050 );\n}\n.tabPane.tabPane-tempUser .tabs {\n  display: flex;\n  align-items: stretch;\n  flex-direction: row;\n  justify-content: space-evenly;\n}\n.tabPane.tabPane-tempUser .tab {\n  width: 33%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabPane": `tabPane_gotaO`,
	"tabContent": `tabContent_sgtI6`,
	"tabs": `tabs_VDba7`,
	"tabLine": `tabLine_n1B4f`,
	"tab": `tab_jqcaO`,
	"tabPane-bottom": `tabPane-bottom_BkBrQ`,
	"tabPane-mobileDetailViewTabs": `tabPane-mobileDetailViewTabs_cduMd`,
	"tabPane-detailViewTabs": `tabPane-detailViewTabs_VHPyw`,
	"tabPane-settingsTabs": `tabPane-settingsTabs_ayNwm`,
	"tabPane-tempUser": `tabPane-tempUser_JWotW`
};
export default ___CSS_LOADER_EXPORT___;
